import { Injectable } from '@angular/core';
import { EndUserLicenseAgreementItem } from '../models/end-user-license-agreement.model';
import { EndUserLicenseAgreementEndpoint } from '../constants/end-user-license-agreement-endpoint';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EndUserLicenseAgreementItemService {
  constructor(private http: WrapperHttpService) {}

  getEulaItem(eulaItemId: number): Observable<EndUserLicenseAgreementItem> {
    return this.http
      .withLoading()
      .get<EndUserLicenseAgreementItem>(
        `${API_URL}${EndUserLicenseAgreementEndpoint.Base}${EndUserLicenseAgreementEndpoint.Version}/${eulaItemId}`,
      );
  }

  saveEulaItem(body: Partial<EndUserLicenseAgreementItem>): Observable<void> {
    return this.http
      .withLoading()
      .post<void>(`${API_URL}${EndUserLicenseAgreementEndpoint.Base}${EndUserLicenseAgreementEndpoint.Version}`, body);
  }

  publishEulaItem(eulaItemId: number): Observable<void> {
    return this.http
      .withLoading()
      .post<void>(
        `${API_URL}${EndUserLicenseAgreementEndpoint.Base}${EndUserLicenseAgreementEndpoint.Version}/${eulaItemId}`,
        {},
      );
  }
}
